var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "color",
    id: "Grua",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.05 47.03",
    style: {
      enableBackground: "new 0 0 23.05 47.03"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62,15.31c2.92,0,14.86,0,17.78,0s2.63-1.45,2.63-2.33c0-2.22,0-5.74,0-6.34c0-3.14-2.5-6.64-5.58-6.64S5.67,0,5.67,0 c-3.1,0-5.66,3.53-5.66,6.61c0,0.6,0,4.3,0,6.45C0.01,13.92-0.3,15.31,2.62,15.31z M19.29,6.6l0.89-3.85 c0.77,0.77,1.62,2.24,1.62,3.87c0,1.4-0.02,5.13-0.03,6.19c-0.01,0.64-0.53,1.15-1.16,1.15H19.3V6.6H19.29z M5.45,1.21h4.8h2.55h4.8 c1.72,0,1.62,0.94,1.62,0.94l-0.94,3.94H4.77L3.83,2.15C3.83,2.15,3.73,1.21,5.45,1.21z M2.82,2.75L3.71,6.6v7.35H2.4 c-0.64,0-1.15-0.51-1.16-1.15c-0.02-1.06-0.03-4.78-0.03-6.19C1.21,4.99,2.05,3.52,2.82,2.75z M17.51,16.21H5.56 c-3.06,0-5.53,2.48-5.53,5.53v16.83c0,3.06,2.48,5.54,5.54,5.53l11.95-0.03c3.05-0.01,5.52-2.48,5.52-5.53v-16.8 C23.04,18.68,20.57,16.21,17.51,16.21z M11.53,41.32c-3.07,0-5.56-2.49-5.56-5.56s2.49-5.56,5.56-5.56s5.56,2.49,5.56,5.56 C17.09,38.83,14.6,41.32,11.53,41.32z M0,45.26h23.04v1.77H0V45.26z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipaIcon);
export default __webpack_public_path__ + "static/media/pipa_icon.c655a04124b2db3324b94986c96b640f.svg";
export { ForwardRef as ReactComponent };